export const emailValidate = (email) => {
  const re = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i;
  const check = email?.match(re);
  return check ? true : false;
};
